import React, { useContext } from 'react';
import { IModifiersContext, ModifiersContext } from '../../../modifiersState/modifiersContext';
import SearchField from 'components/SearchField/SearchField';

export const Search: React.FC = () => {
	const { changeSearchString, searchString, modifiersByCustomer, modifiersByRestaurant } =
		useContext<IModifiersContext>(ModifiersContext);

	return (
		<SearchField
			onChangeSelectSearchString={changeSearchString}
			searchString={searchString}
			delay={modifiersByCustomer.totalCount || modifiersByRestaurant.totalCount ? 800 : undefined}
		/>
	);
};
